import React from "react";
import i18n from "../../../i18n";
import FlexWrap from "../../../components/FlexWrap/FlexWrap";
import {LoadingGenderButtonStyled, LoadingGenderSelectContainer} from "./LoadingView.style";
import TouchEffect from "../../../components/TouchEffect/TouchEffect";
import ProcessingLoader from "../../../components/ProcessingLoader/ProcessingLoader";
import processingManager from "../../../photolab/ProcessingManager";
import SurveyView from "../SurveyView";
import {contextTypeKeys} from "../../../photolab/etc";

const genders = {
  male: "male",
  female: "female",
  human: "human",
};

class LoadingView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      //textIndex: Math.floor(Math.random() * (this.texts.length - 1)),
      gender: 'male'
    };
  }

  handleCancelButtonClick = () => {
    this.props.onCancel && this.props.onCancel();
  };

  render() {
    const processing = processingManager.processing;
    const creative = processing && processing.creatives.first();
    const shouldShowSurvey = false;

    return <main className={`loader ${shouldShowSurvey ? "loader-survey" : ""}`}>
      <button
        hidden
        className="loader-cancel-button"
        onClick={this.handleCancelButtonClick}>
        {i18n.t("cancel")}
      </button>

      <ProcessingLoader
        creative={creative}
        imagesUrls={this.props.imagesUrls}
        blur={this.props.imageIsBlurred}
        processingTookSecondsApprox={20}
        texts={[
          "processing_text_1",
          "processing_text_2",
          "processing_text_3",
          "processing_text_4",
        ]}
        stroke="rgb(30, 43, 55)"
      />

      {shouldShowSurvey && <SurveyView onAnswered={(answer) => {
        this.props.onContextTypeChanged(answer === "hotlook" ? contextTypeKeys.template : contextTypeKeys.original);
      }} />}

      <LoadingGenderSelectContainer direction='column' align="center" hidden={!this.props.gender || this.props.isMultiface}>
        <p>{i18n.t("processing_footer_text")}</p>
        <FlexWrap justify="center" gap={16}>
          <LoadingGenderButtonStyled
            active={this.props.gender === genders.female}
            onClick={() => this.props.onGenderChanged(genders.female)}>
            {i18n.t("processing_female_button")}
            <TouchEffect />
          </LoadingGenderButtonStyled>
          <LoadingGenderButtonStyled
            active={this.props.gender === genders.male}
            onClick={() => this.props.onGenderChanged(genders.male)}>
            {i18n.t("processing_male_button")}
            <TouchEffect />
          </LoadingGenderButtonStyled>
          <LoadingGenderButtonStyled
            hidden
            active={this.props.gender === genders.human}
            onClick={() => this.props.onGenderChanged(genders.human)}>
            {i18n.t("processing_human_button")}
            <TouchEffect />
          </LoadingGenderButtonStyled>
        </FlexWrap>
      </LoadingGenderSelectContainer>
    </main>;
  }
}

export default LoadingView;